import { Component, OnInit } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { TelemedicineService } from 'src/modules/telemedicine/services/telemedicine.service';
import { SmartModalService } from 'src/modules/base/services/smart-modal.service';
import { Observable } from 'rxjs';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { DialogRef } from 'src/modules/base/components/dialog/dialog-ref';

@Component({
    selector: 'kx-doctor-list',
    templateUrl: './doctor-list.component.html',
    styleUrls: ['./doctor-list.component.scss'],
    standalone: false
})
export class DoctorListComponent implements OnInit {
  doctorList: any
  data: any;

  constructor(
    private baseServices: BaseService,
    private teleService: TelemedicineService,
    private modal: SmartModalService,
    private alert: AlertsService,
    private loader: LoaderService,
    private dialogRef: DialogRef
  ) { }

  ngOnInit() {
    console.log("this data si ;;", this['data']);
    this.data = this['data'];
    this.getDoctorList()
  }

  getDoctorList() {
    this.loader.showSpinner()
    this.baseServices.get('GET_ONLINE_DOCTORS', '', 'practitioner_facility_details', 'facility-management').subscribe((res: any) => {
      this.doctorList = res.resource;
      this.loader.hideSpinner();
    })
  }

  openVideoCall(list: any) {
    this.loader.showSpinner();
    let resource = {
      "doctor_id": list.practitioner_id,
      "orderId": this.data.orderId,
      "channel_id": this.data.serviceRequestId
    }
    this.sendNotification$(resource).subscribe((res: any) => {
      this.loader.hideSpinner()
      if (res) {
        if (res.errCode == -1) {
          this.alert.error(res.message)
        } else {
          var Obj = {
            "channel_id": "serviceRequestId",
            "appLink": "videocall",
          }
          this.teleService.initCallData(list.practitioner_id, list.display_name, this.data['serviceRequestId'], this.data['orderId'], Obj, this.data);
          this.modal.close();
          if (this.dialogRef)
            this.dialogRef.close()
        }
      }
    },
      (err) => {
        console.error("error in getting data", err);
      }
    )
  }

  sendNotification$(resource: any): Observable<any> {
    return this.baseServices.action(resource, "VIDEO_CALL_FOR_DOCTOR", "ambulance-management", "ambulance_approve")
  }

}
